import { render, staticRenderFns } from "./DomainInfoView.vue?vue&type=template&id=04057671&"
import script from "./DomainInfoView.vue?vue&type=script&lang=js&"
export * from "./DomainInfoView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04057671')) {
      api.createRecord('04057671', component.options)
    } else {
      api.reload('04057671', component.options)
    }
    module.hot.accept("./DomainInfoView.vue?vue&type=template&id=04057671&", function () {
      api.rerender('04057671', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/domains/DomainInfoView.vue"
export default component.exports